/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router components

// prop-types is a library for typechecking of props

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";
import ArgonTypography from "components/ArgonTypography";

function MessageCard({ image, text, action }) {
  return (
    <Card>
      <ArgonBox p={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={4}>
            <ArgonBox
              component="img"
              src={image}
              alt="message-image"
              borderRadius="lg"
              shadow="md"
              width="100%"
              display="inherit"
            />
          </Grid>
          <Grid item xs={8}>
            <ArgonBox mb={2} lineHeight={1.4}>
              <ArgonTypography variant="button" color="text" fontWeight="medium">
                {text}
              </ArgonTypography>
            </ArgonBox>
            {action && (
              <>
                {action.type === "internal" ? (
                  <ArgonButton
                    component={Link}
                    to={action.route}
                    color={action.color}
                    variant="gradient"
                    size="small"
                  >
                    {action.label}
                  </ArgonButton>
                ) : (
                  <ArgonButton
                    component="a"
                    href={action.route}
                    target="_blank"
                    rel="noreferrer"
                    color={action.color}
                    variant="gradient"
                    size="small"
                  >
                    {action.label}
                  </ArgonButton>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </ArgonBox>
    </Card>
  );
}

// Typechecking props for the MessageCard
MessageCard.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  action: PropTypes.shape({
    type: PropTypes.oneOf(["external", "internal"]).isRequired,
    route: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
      "default",
      "primary",
      "secondary",
      "info",
      "warning",
      "error",
      "light",
      "dark",
    ]).isRequired,
    label: PropTypes.string.isRequired,
  }), // Remove .isRequired to make action optional
};

// Add defaultProps to provide a default value for action
MessageCard.defaultProps = {
  action: null,
};

export default MessageCard;
